import { useState } from 'react'
import { Netzstreifen } from '../../components/Netzstreifen'
import { Link, Navigate, useNavigate } from 'react-router-dom'

import { useCreateTrip, useMe } from '../../hooks/queries'
import { BackIcon } from '../../components/Icons'
import { Restzeichen } from '../../components/Restzeichen'
import { useTextgrenzen } from '../../hooks/useTextgrenzen'
import { useTexte } from '../../texte'

export function NewTripPage() {
  const t = useTexte().reise.neu
  const grenzen = useTextgrenzen()
  const create = useCreateTrip()
  const me = useMe()
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [von, setVon] = useState('')
  const [bis, setBis] = useState('')

  // Wer nur mitliest, bekommt den Knopf gar nicht zu sehen -- über die Adresse
  // käme er trotzdem hierher, und ein Formular, das beim Absenden abgewiesen
  // wird, ist eine Zumutung. Der Server lehnt es ohnehin ab.
  if (me.data && !me.data.may_create_trips) return <Navigate to="/" replace />

  return (
    <>
      <header className="bar">
        <Link className="icon-button" to="/" aria-label={t.zurueck}>
          <BackIcon />
        </Link>
        <h2 className="bar__title bar__grow">{t.titel}</h2>
      </header>
      <Netzstreifen />

      <div className="scroll-panel">
        <form
          className="card card--mittig"
          onSubmit={(event) => {
            event.preventDefault()
            create.mutate(
              // Leere Felder gar nicht erst mitschicken -- der Server
              // unterscheidet "nicht gesetzt" von "leer".
              { title, description, starts_on: von || undefined, ends_on: bis || undefined },
              // Direkt in die Einladung: ohne Empfänger ist eine Reise noch
              // kein Beitrag an alle.
              { onSuccess: (trip) => navigate(`/t/${trip.id}/info`) },
            )
          }}
        >
          <p className="card__lead">{t.lead}</p>

          {create.isError && <p className="notice" role="alert">{create.error.message}</p>}

          <label className="field">
            <span className="field__label">{t.feldTitel}</span>
            <input
              className="field__input"
              required
              maxLength={grenzen.title}
              placeholder={t.platzhalter}
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </label>

          <label className="field">
            <span className="field__label">{t.beschreibung}</span>
            <textarea
              className="field__input"
              rows={3}
              maxLength={grenzen.trip_description}
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
            <Restzeichen wert={description} grenze={grenzen.trip_description} />
          </label>

          {/* Der Zeitraum darf offen bleiben: das Ende steht am Anfang
              selten fest, und eine Reise ohne festen Plan ist der Normalfall. */}
          <div className="row row--wrap">
            <label className="field field--halb">
              <span className="field__label">{t.von}</span>
              <input
                className="field__input"
                type="date"
                value={von}
                max={bis || undefined}
                onChange={(event) => setVon(event.target.value)}
              />
            </label>
            <label className="field field--halb">
              <span className="field__label">{t.bis}</span>
              <input
                className="field__input"
                type="date"
                value={bis}
                min={von || undefined}
                onChange={(event) => setBis(event.target.value)}
              />
            </label>
          </div>

          <button className="button button--weit" type="submit" disabled={create.isPending}>
            {create.isPending ? t.wirdAngelegt : t.anlegen}
          </button>
        </form>
      </div>
    </>
  )
}
